<template>
    <div
        id="ChatHistoryListTwo"
        :style="{
            background: 'linear-gradient(0deg, var(--background-color-first), var(--background-color-second)) !important',
        }"
    >
        <div v-if="selectedConversationId === undefined && !loading" class="list-container">
            <div class="header">
                <Input
                    inputType="text"
                    :placeHolder="$t('message.searchChat')"
                    @v-model="(e) => (searchValue = e)"
                    :value="searchValue"
                    firstIcon="Search"
                />
            </div>
            <div v-if="!chatList.length" class="empty-state">
                <span class="empty-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z" />
                    </svg>
                </span>
                <p>{{ $t("message.noChatHistory") }}</p>
            </div>
            <div v-else class="list">
                <button type="button" class="item" v-for="chat in chatList" :key="chat._id" @click="selectChat(chat)">
                    <div class="avatar">
                        <img v-if="avatarOf(chat)" :src="avatarOf(chat)" alt="" />
                        <span v-else class="initial">{{ initialOf(titleOf(chat)) }}</span>
                    </div>
                    <div class="info">
                        <div class="top-row">
                            <span class="name" :title="titleOf(chat)">{{ titleOf(chat) }}</span>
                            <span class="date">{{ getDate(chat) }}</span>
                        </div>
                        <div class="preview" v-if="previewOf(chat)">
                            <span v-if="previewOf(chat).mine" class="preview-you">{{ $t("message.you") }}:</span>
                            <span class="preview-text" v-html="messageText(previewOf(chat).text)"></span>
                        </div>
                    </div>
                    <span class="chevron" aria-hidden="true"></span>
                </button>
            </div>
        </div>
        <div v-if="selectedConversationId && !loading">
            <ChatHistoryDetail
                :colors="colors"
                :message-styling="messageStyling"
                :vuescrollOptions="vuescrollOptions"
                :messages="messages"
                :participants="participants"
            />
        </div>
        <div class="loading-bar" v-if="loading">
            <DynamicSvg :name="'Loading'" />
        </div>
    </div>
</template>
<script>
import { fetchChatHistory } from "../../api/visitor";
import { mapState } from "vuex";
import log2 from "../../utils/log2";
import dateUtils from "../../utils/DateUtil";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";
import request from "../../utils/request";
import * as _ from "lodash";
import Input from "../../common/Input.vue";
import ChatHistoryDetail from "./ChatHistoryDetail.vue";
import DynamicSvg from "../../common/DynamicSvg.vue";
import { pickPreview, conversationTitle, initialOf, relativeTime } from "../../utils/chatHistoryList";
import { convertHistoryMessages } from "../../utils/convertHistoryMessages";

const log = log2("ChatHistoryList");
export default {
    name: "ChatHistoryListTwo",
    components: { Input, ChatHistoryDetail, DynamicSvg },
    props: {
        vuescrollOptions: {
            type: Object,
        },
        colors: {
            type: Object,
        },
        messageStyling: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedConversationId: undefined,
            chats: [],
            loading: true,
            messages: [],
            participants: [],
            page: 1,
            loadMore: false,
            searchValue: null,
            chatList: [],
        };
    },

    methods: {
        getDate(c) {
            return relativeTime(c.createdDate, this.$i18n.locale);
        },
        getTitle() {
            const c = this.chats.find((x) => x._id === this.selectedConversationId);
            return `${this.$t("message.chatDate")} ` + dateUtils.formatDateTime(c.createdDate);
        },
        titleOf(c) {
            return conversationTitle(c, (k) => this.$t(`message.${k}`));
        },
        previewOf(c) {
            return pickPreview(c.messages);
        },
        avatarOf(c) {
            return _.get(c, "users[0].gravatar") || null;
        },
        initialOf,
        getChatHistory() {
            this.loading = true;
            fetchChatHistory(this.site._id, this.visitorId, this.page)
                .then((res) => {
                    log("fetchChatHistory", res.data);
                    const { conversations, totalCount, currentPage, pageSize } = res.data;
                    // Ayni sayfayi iki kez eklemesin: liste chats'in kendisi
                    this.chats = _.uniqBy([...this.chats, ...conversations], "_id");
                    this.chatList = this.chats;
                    this.loadMore = Math.ceil(totalCount / pageSize) !== currentPage;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        messageText(msg) {
            let escaped = htmlUnescape(msg.trim());

            let res = Autolinker.link(escaped, {
                className: "chatLink",
                truncate: { length: 50, location: "smart" },
            });

            return res;
        },
        selectChat(c) {
            log("selectChat", c);
            this.selectedConversationId = c._id;
            this.loadOldMessages();
        },
        loadOldMessages() {
            log("loadOldMessages", this.selectedConversationId);
            this.loading = true;
            if (this.selectedConversationId);
            {
                return request({
                    url: `/conversations/${this.selectedConversationId}/messages`,
                    method: "get",
                })
                    .then((response) => {
                        this.messages = [];
                        let items = response.data.data;
                        items = _.orderBy(
                            _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                            (q) => new Date(q.createdDate).getTime(),
                            "asc"
                        );
                        log("messages ->", items);
                        this.messages = convertHistoryMessages(items, dateUtils.formatHour);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            visitorId: (state) => state.chat.visitorId,
            settings: (state) => state.setting.settings,
            backgroundColorFirst: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst",
                    "#fff"
                ),
            backgroundColorSecond: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorSecond",
                    "#fff"
                ),
        }),
    },
    mounted() {
        dateUtils.initializeLocale(this.$i18n.locale);
        if (this.site && this.visitorId) this.getChatHistory();
    },
    updated() {
        dateUtils.updateLocale(this.$i18n.locale);
    },
    watch: {
        chats() {},
        searchValue() {
            const q = (this.searchValue || "").trim().toLocaleLowerCase("tr");
            if (!q) {
                this.chatList = this.chats;
                return;
            }
            this.chatList = this.chats.filter((chat) => {
                const preview = this.previewOf(chat);
                const hay = [this.titleOf(chat), preview ? preview.text : ""].join(" ").toLocaleLowerCase("tr");
                return hay.includes(q);
            });
        },
    },
};
</script>
<style lang="scss">
#ChatHistoryListTwo {
    overflow-y: auto;
    overflow-x: hidden;

    .list-container {
        width: 100%;
        height: 100%;

        .header {
            display: flex;
            justify-content: center;
            padding: 4px 16px 0;
            margin-bottom: 8px;
            input {
                width: 100%;
            }

            // Arama kutusu: gri dolgu yerine beyaz kutu + ince cerceve (formla ayni dil)
            #Input .container {
                background-color: #fff;
                border-color: rgba(15, 23, 42, 0.12);
                transition: border-color 160ms ease, box-shadow 160ms ease;

                &:hover {
                    border-color: rgba(15, 23, 42, 0.22);
                }

                &:focus-within {
                    border-color: var(--button-color);
                    box-shadow: 0 0 0 3px color-mix(in srgb, var(--button-color) 16%, transparent);
                }
            }
        }

        .empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            padding: 48px 24px;
            color: var(--primary-text);
            text-align: center;

            .empty-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 56px;
                height: 56px;
                border-radius: 50%;
                background: rgba(15, 23, 42, 0.05);
                color: var(--button-color);
            }

            p {
                margin: 0;
                font-size: 13.5px;
                opacity: 0.6;
            }
        }

        .list {
            padding: 0 6px 12px;
        }

        // Satir: avatar | ad + saat / onizleme | chevron. Dugme olarak ciziliyor
        // ki klavye ile de gezilebilsin.
        .item {
            display: flex;
            align-items: center;
            gap: 12px;
            width: 100%;
            padding: 11px 10px 11px 12px;
            border: 0;
            border-radius: var(--sps-radius-md, 12px);
            background: transparent;
            color: var(--primary-text);
            font: inherit;
            text-align: left;
            cursor: pointer;
            user-select: none;
            transition: background-color 120ms ease;

            & + .item {
                position: relative;

                &::before {
                    content: "";
                    position: absolute;
                    left: 64px;
                    right: 12px;
                    top: 0;
                    border-top: 1px solid rgba(15, 23, 42, 0.06);
                }
            }

            &:hover,
            &:focus-visible {
                background-color: rgba(15, 23, 42, 0.045);
                outline: none;
            }

            &:hover + .item::before,
            &:hover::before {
                border-top-color: transparent;
            }

            &:active {
                background-color: rgba(15, 23, 42, 0.08);
            }

            .avatar {
                flex-shrink: 0;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                overflow: hidden;
                background: var(--button-color, #7b2ff7);
                color: var(--button-text-color, #fff);
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .initial {
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 1;
                }
            }

            .info {
                flex: 1;
                min-width: 0;
                display: flex;
                flex-direction: column;
                gap: 3px;
            }

            .top-row {
                display: flex;
                align-items: baseline;
                justify-content: space-between;
                gap: 10px;
            }

            .name {
                flex: 1;
                min-width: 0;
                font-size: 14px;
                font-weight: 600;
                line-height: 1.3;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .date {
                flex-shrink: 0;
                font-size: 11.5px;
                line-height: 1.3;
                opacity: 0.5;
                white-space: nowrap;
            }

            .preview {
                display: flex;
                gap: 4px;
                min-width: 0;
                font-size: 13px;
                line-height: 1.35;
                opacity: 0.62;

                .preview-you {
                    flex-shrink: 0;
                    font-weight: 500;
                }

                .preview-text {
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    p {
                        display: inline;
                        margin: 0;
                    }

                    a {
                        color: inherit;
                        text-decoration: none;
                    }
                }
            }

            .chevron {
                flex-shrink: 0;
                width: 7px;
                height: 7px;
                margin-right: 4px;
                border-right: 1.6px solid currentColor;
                border-bottom: 1.6px solid currentColor;
                transform: rotate(-45deg);
                opacity: 0.3;
            }
        }
    }

    .loading-bar {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/ChatHistoryListTwo.vue